module.exports = __webpack_public_path__ + "static/media/wide.5a5579a7.jpg";